// v16.92 — Sentry init: PHẢI được import ĐẦU TIÊN trong index.js.
// v17.11 Lazy Load Đợt 2 — Sentry.init() sync (ErrorBoundary cần) NHƯNG
// browserTracingIntegration được DEFER sau `window.load` → parse cost của
// tracing (~40% Sentry SDK) rời khỏi critical path, mobile TTI cải thiện.
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

// PR-A — Reduced-runtime embed: iframe ?embed=1 không init Sentry
// (ErrorBoundary vẫn render bình thường khi chưa init).
const _isEmbed = (() => {
  try {
    return new URLSearchParams(window.location.search).get("embed") === "1";
  } catch {
    return false;
  }
})();

const IGNORE_ERRORS = [
  // Zalo in-app browser
  /zaloJSV2/i,
  /zaloJSV/i,
  /Zalo Mini App/i,
  // Facebook in-app browser
  /_AutofillCallbackHandler/i,
  /FBSDK/i,
  /fb_sdk/i,
  /fbq is not defined/i,
  // Crypto extensions
  /MetaMaskInpageProvider/i,
  // TikTok / Instagram in-app
  /instantSearchSDK/i,
  /tikt0kjsapi/i,
  /tiktokSDK/i,
  // Other Asian in-app browsers
  /vivowebview/i,
  /MttJsBridge/i,
  /QBJSBridge/i,
  /huaweiclient/i,
  /samsungclient/i,
  /OperaJSCallback/i,
  // Generic cross-origin
  /^Script error\.?$/i,
  // ResizeObserver loop noise (Chrome/Safari benign warning)
  /ResizeObserver loop/i,
  // Network aborts khi user điều hướng đi trước khi request xong
  /Non-Error promise rejection captured with value: undefined/i,
];

if (dsn && !_isEmbed) {
  // Init SLIM — chỉ error capture. Tracing add sau khi window load.
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "development",
    // v17.11 — integrations rỗng ban đầu. Add browserTracing sau khi
    // window load để không cản LCP mobile.
    integrations: [],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^\//, process.env.REACT_APP_BACKEND_URL],
    ignoreErrors: IGNORE_ERRORS,
  });

  // Defer browserTracing đến sau window.load — page interactive rồi mới
  // instrument navigation/pageload spans (miss được vài giây đầu, chấp
  // nhận đổi lấy TTI mobile).
  const enableTracing = () => {
    try {
      Sentry.addIntegration(Sentry.browserTracingIntegration());
    } catch { /* noop */ }
  };
  if (typeof window !== "undefined") {
    if (document.readyState === "complete") {
      // Page đã load xong → defer 1 idle tick.
      const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
      schedule(enableTracing, { timeout: 3000 });
    } else {
      window.addEventListener("load", () => {
        const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
        schedule(enableTracing, { timeout: 3000 });
      }, { once: true });
    }
  }
}
